import DataSource from "../DataSource/DataSource";
export default class UzivatelService{

  constructor(server){
    this.server = server;
  }

  listSource(){
    return new DataSource(this.server, "auth.uzivatel.source", {limit: 10})
  }


  save(item){
    return this.server("auth.uzivatel.save", {uzivatel: item});
  }

  disable(uzivatelId){
    return this.server("auth.uzivatel.disable", {id: uzivatelId});
  }

  enable(uzivatelId){
    return this.server("auth.uzivatel.enable", {id: uzivatelId});
  }

  reactivate(uzivatelId){
    return this.server("auth.uzivatel.reactivate", {id: uzivatelId});
  }

  setPassword(uzivatelId, password){
    return this.server("auth.uzivatel.save", {uzivatel: {id: uzivatelId, password: password}}); 
  }

  listRole(){
    return this.server("auth.role.list");
  }

  listPermissions(){
    return this.server("auth.permissions.list");
  }

  saveRole(role){
    return this.server("auth.role.save", {role: role});
  }

  removeRola(rolaId){
    return this.server("removeRola", {id: rolaId});
  }

}


// WEBPACK FOOTER //
// ./src/Uzivatel/UzivatelService.js